import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// JS Files

// Others File
import QuestionsCard from "./QuestionsCard";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useFetch from "../../context/useFetch";

const Questions = () => {
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const getFaqList = useFetch({
    method: "get",
    url: `Faq_Service/get_top_faq`,
    trigger: true,
    noHeader: true,
    setter: setDataList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <div className="mx-4 md:mx-16 mb-2 mt-10 md:mt-20">
        <p className="header">سوالات پرتکرار</p>
      </div>
      <div className="bg-myblue-500">
        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mt-8 mx-4 px-4 md:px-16 py-8">
          {dataList.map((item, index) => {
            return [
              <QuestionsCard
                header={item.question}
                text={item.answer}
                key={index}
              />,
            ];
          })}
        </div>
        <div className="flex justify-end items-center mx-4 md:mx-16 pb-4">
          <span
            onClick={() => navigate("/questions")}
            className="text-black text-sm cursor-pointer"
          >
            مشاهده همه سوالات
          </span>
          <ArrowBackIosIcon
            className="text-black"
            style={{ fontSize: "1rem" }}
          />
        </div>
      </div>
    </>
  );
};
export default Questions;
